/* ============================================================================
 * Triple Y: "כדאי להוסיף" בדף המוצר — הוספה בלחיצה אחת.
 *
 * הסניפט כבר הטביע את מזהה הווריאנט הנכון על כל כפתור, ולכן כאן אין שום
 * לוגיקת בחירה. זו כל הנקודה: הלקוח לוחץ, והווריאנט של הדגם שלו נכנס.
 *
 * 🔴 **אין כאן דגל חבילה (properties).** ההנחה של החבילה חלה רק דרך
 *    התיבה בעגלה, ופריט שנוסף כאן נמכר במחיר מלא. הוספת הדגל כאן הייתה
 *    מזכה בהנחה בלי החבילה, ומפצלת את מה שהלקוח רואה ממה שהוא משלם.
 *
 * הקובץ: snippets/product-accessory-picks.liquid
 * ========================================================================= */
(function () {
  'use strict';

  /* הסניפט מרונדר פעם אחת לדף, אבל הקובץ נטען עם defer ויכול להיטען שוב
   * אם הבלוק מרונדר מחדש בעורך התמה. שומר מפני הרשמה כפולה. */
  if (window.tyPicksReady) return;
  window.tyPicksReady = true;

  var ERROR_TEXT = 'ההוספה נכשלה. אפשר לנסות שוב.';

  function showError(root, message) {
    var box = root.querySelector('[data-ty-picks-error]');
    if (!box) return;
    box.textContent = message || ERROR_TEXT;
    box.classList.remove('hidden');
  }

  function clearError(root) {
    var box = root.querySelector('[data-ty-picks-error]');
    if (box) box.classList.add('hidden');
  }

  /* תוכן המגירה יושב בתוך <template class="deferred"> עד ש-init() מושך
   * אותו פנימה (lazy_load_js של הערכה). ‏product-form.js עושה את זה
   * ב-connectedCallback, ולכן בדף מוצר רגיל המגירה כבר מאותחלת. כאן זה
   * ליתר ביטחון, לתבנית שאין בה טופס מוצר. */
  var drawerEl = document.querySelector('cart-drawer');
  if (drawerEl && window.customElements) {
    customElements.whenDefined('cart-drawer').then(function () {
      if (typeof drawerEl.init === 'function') drawerEl.init();
    });
  }

  /* המגירה נבנית מחדש מהשרת ונפתחת מעצמה בתוך renderContents.
   * זה בדיוק מה ש-product-form.js של הערכה עושה, ולכן ההתנהגות אחרי
   * לחיצה כאן זהה להוספה רגילה לעגלה. */
  function drawerSections() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.getSectionsToRender !== 'function') return null;
    if (typeof drawer.init === 'function') drawer.init();
    return {
      drawer: drawer,
      ids: drawer.getSectionsToRender().map(function (s) { return s.id; }),
    };
  }

  /* 🔴 **המחלקה is-empty על <cart-drawer> נשארת תקועה, וזו הייתה השגיאה.**
   *
   * היא מרונדרת בצד השרת לפי מצב הסל בטעינת הדף, ו-renderContents מסיר
   * אותה רק מ-.drawer__inner הפנימי. האלמנט החיצוני נשאר `is-empty`
   * לנצח. אחר כך, ב-open():
   *
   *   containerToTrapFocusOn = this.classList.contains('is-empty')
   *     ? this.querySelector('.drawer__inner-empty')   ⟵ כבר לא קיים
   *     : document.getElementById('CartDrawer');
   *
   * כלומר null, ו-trapFocus מת על null.querySelectorAll.
   * **הפריט כן נכנס לסל והמגירה כן נפתחת**, ולכן זה נראה כמו הצלחה עם
   * שגיאה מסתורית בקונסול, ולא כמו כשל.
   *
   * אחרי הוספה מוצלחת הסל אינו ריק בהגדרה, ולכן ההסרה כאן נכונה תמיד.
   * נתפס 20.08.2026 במדידה של isEmptyClass מול innerEmpty אחרי הלחיצה. */
  function unmarkEmpty(drawer) {
    if (drawer) drawer.classList.remove('is-empty');
  }

  function bind(button) {
    button.addEventListener('click', function () {
      var root = button.closest('[data-ty-picks]');
      var variantId = button.dataset.variantId;
      if (!variantId || button.getAttribute('aria-disabled') === 'true') return;

      clearError(root);
      button.setAttribute('aria-disabled', 'true');
      button.classList.add('is-loading');

      var target = drawerSections();
      var body = { items: [{ id: Number(variantId), quantity: 1 }] };
      if (target) {
        body.sections = target.ids;
        body.sections_url = window.location.pathname;
      }

      fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      })
        .then(function (r) { return r.json(); })
        .then(function (response) {
          /* שופיפיי מחזירה 200 עם שדה status על שגיאת מלאי. בלי הבדיקה
           * הזאת כישלון נראה כמו הצלחה שקטה. */
          if (response.status) {
            showError(root, response.description || response.message);
            return;
          }
          if (target && response.sections) {
            unmarkEmpty(target.drawer);
            target.drawer.renderContents(response);
            /* אותו אירוע ש-product-form.js משדר, כדי שבועת הסל בהדר וכל
             * מנוי אחר יתעדכנו. בלעדיו הרכיבים האלה מפגרים אחרי הסל. */
            if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
              window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
                source: 'ty-accessory-picks',
                productVariantId: variantId,
                cartData: response,
              });
            }
            return;
          }
          window.location.href = window.routes.cart_url;
        })
        .catch(function () {
          showError(root);
        })
        .finally(function () {
          button.setAttribute('aria-disabled', 'false');
          button.classList.remove('is-loading');
        });
    });
  }

  document.querySelectorAll('[data-ty-pick-add]').forEach(bind);
  /* ty-picks-bind >>> 22.09.2026
   * ty-offer-color-sync.js מחליף את הבלוק כשמגן העדשות נוסף או יורד בהחלפת
   * צבע, ומחבר את הכפתורים החדשים דרך הפונקציה הזו. */
  window.tyPicksBind = bind;
  /* <<< ty-picks-bind */
})();
